import { render, staticRenderFns } from "./PohRoutes.vue?vue&type=template&id=96d418c4&"
import script from "./PohRoutes.vue?vue&type=script&lang=js&"
export * from "./PohRoutes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports